import request from '@/utils/request'

let getList=(data)=>request.post('/api/customerService/list',data)
let add=(data)=>request.post('/api/customerService/add',data)
let edit=(data)=>request.post('/api/customerService/edit',data)
let del=(data)=>request.post('/api/customerService/delete',data)
let exp=()=>request.get('/api/customerService/export')

export default {
  getList,
  add,
  edit,
  del,
  exp
}